
export const restrictToAlphabetic = (e) => {
    let value = e.target.value;

    // Remove leading spaces
    value = value.replace(/^\s+/, '');

    // Remove non-alphabetic characters (except spaces)
    value = value.replace(/[^a-zA-Z\s]/g, '');

    // Replace multiple spaces with a single space
    value = value.replace(/\s{2,}/g, ' ');

    // Update the input field with the formatted value
    e.target.value = value;
}

export const OnlyNumeric = (e) => {
    let value = e.target.value;
    let numbers = value.replace(/[^0-9]/g, "");
    e.target.value = numbers;
}

export const validateMobile = (mobile) => {
        const mobileRegex = /^[6-9]\d{9}$/;
        return mobileRegex.test(mobile);
};
